import {ConfigProvider} from 'antd';
import enUsDesktop from 'antd/es/locale/en_US';
import deDeDesktop from 'antd/es/locale/de_DE';
import {observer} from 'mobx-react-lite';
import appConfig from '../../utils/appConfig';
import {useStore} from '../../hooks/useStore';
import {useBreakpoint} from './Viewport';

const languages = {
  en: {
    desktop: enUsDesktop,
  },
  de: {
    desktop: deDeDesktop,
  },
};

export const Locale = observer(({children}) => {
  const {clientStore} = useStore();
  const locale = languages[appConfig.language] || languages.en;
  const breakpoint = useBreakpoint();
  clientStore.setBreakpoint(breakpoint);

  document.documentElement.lang = `${appConfig.language}-CH`;

  return (
    <ConfigProvider locale={locale.desktop}>
      {children}
    </ConfigProvider>
  );
});
